<section class="work" id="work">
  <div class="titleskill reveal">
    <h2 class="titleskill colorw"><span>Our Achievements:</span> <span>Where Innovation Comes to Life</span></h2>
    <p>
      From groundbreaking e-commerce solutions to intuitive learning platforms, our projects are redefining what’s possible. Let them inspire your next big leap.
    </p>
  </div>
  <div class="content">


    <div class="card reveal">
      <div class="card-info">
        <h3>E-Commerce Revolution: Turning Browsers into Buyers</h3>
        <p>With stunning 3D visualization, AI-driven pricing, and cutting-edge strategies, we’ve helped businesses achieve record-breaking sales.</p>
      </div>
    </div>

    <div class="card reveal">
      <div class="card-info">
        <h3>Finance Made Simple: Empowering Everyday Decisions</h3>
        <p>Our financial management app has transformed how people take charge of their personal finances, making the complex simple.</p>
      </div>
    </div>

    <div class="card reveal">
      <div class="card-info">
        <h3>E-Learning Excellence: Personalized and Powerful</h3>
        <p>We’ve reimagined education with adaptive, performance-driven platforms that make learning accessible and effective for everyone</p>
      </div>
    </div>

  </div>
  <div class="title">
    <a href="#work" class="btn">See all our projects</a>
  </div>
</section>

<section class="contact" id="contact">
  <div class="title reveal">
    <h2 class="title">Contact Me</h2>
  </div>
  <div class="content">

    <div class="row">
      <div class="contact-form reveal">

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <h3>Send a Message</h3>
          <div class="input-box">
            <label for="name">First Name</label>
            <input id="name" formControlName="name" type="text" placeholder="Your First Name" />
            <div *ngIf="contactForm.get('name')?.invalid && contactForm.get('name')?.touched" class="error">
              First name is required.
            </div>
          </div>
          <div class="input-box">
            <label for="email">Email</label>
            <input id="email" formControlName="email" type="email" placeholder="Your email" />
            <div *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched" class="error">
              Please enter a valid email address.
            </div>
          </div>
          <div class="input-box">
            <label for="subject">Subject</label>
            <textarea id="subject" formControlName="subject" placeholder="Your Subject"></textarea>
            <div *ngIf="contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched" class="error">
              Subject is required.
            </div>
          </div>
          <div class="input-box">
            <p>By submitting this form, you agree to our privacy policy.</p>
            <button type="submit" class="btn">Send</button>
          </div>
          <div *ngIf="message" class="success">
            <p>{{ message }}</p>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="card reveal">
        <div class="contact-icon">
          <img src="Place_Marker.png" class="fa-solid fa-location-dot"/>
        </div>
        <div class="info">
          <h3>Adresse</h3>
          <span>Cité El Menezeh 2, Kalaa Sghira, Maison 216, Sousse, Tunisie</span>
        </div>
      </div>
      <div class="card reveal">
        <div class="contact-icon">
          <a href="tel:+21652920993" aria-label="phone number">
            <img src="Ringer_Volume.png" class="fas fa-phone"/>
          </a>
        </div>
        <div class="info">
          <h3>phone number</h3>
          <span>+216 52920993</span>
        </div>
      </div>
      <div class="card reveal">
        <div class="contact-icon">
          <a href="mailto:mohamedaimenhec@gmail.com" aria-label="Email">
            <img src="Letter.png" class="fas fa-envelope"/>
          </a>
        </div>
        <div class="info">
          <h3>Email</h3>
          <span>
            <span>mohamedaimenhec&#64;gmail.com</span>
          </span>
        </div>
      </div>
      <div class="card reveal">
        <div class="contact-icon">
          <a href="https://tetesss.pythonanywhere.com/" aria-label="webSite">
            <img src="Website.png" class="fas fa-globe"/>
          </a>
        </div>
        <div class="info">
          <h3>another webSite</h3>
          <span>https://tetesss.pythonanywhere.com/</span>
        </div>
      </div>
    </div>
  </div>
</section>
